<template>
  <div>
    <div style="position: relative; width: 1024px; display: inline-block;">

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="860" height="263" viewBox="0 0 860 263">
        <defs>
          <ellipse id="prefix__b" cx="16.442" cy="15.5" rx="14.442" ry="15.5"/>
          <ellipse id="prefix__d" cx="16.442" cy="15.5" rx="14.442" ry="15.5"/>
          <ellipse id="prefix__f" cx="16.442" cy="15.5" rx="14.442" ry="15.5"/>
          <filter id="prefix__a" width="134.6%" height="132.3%" x="-13.8%" y="-12.9%" filterUnits="objectBoundingBox">
            <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5"/>
            <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
            <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter2"/>
            <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation="1"/>
            <feColorMatrix in="shadowBlurOuter2" result="shadowMatrixOuter2" values="0 0 0 0 0.880286397 0 0 0 0 0.885493323 0 0 0 0 0.889832428 0 0 0 1 0"/>
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1"/>
              <feMergeNode in="shadowMatrixOuter2"/>
            </feMerge>
          </filter>
          <filter id="prefix__c" width="134.6%" height="132.3%" x="-13.8%" y="-12.9%" filterUnits="objectBoundingBox">
            <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5"/>
            <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
            <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter2"/>
            <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation="1"/>
            <feColorMatrix in="shadowBlurOuter2" result="shadowMatrixOuter2" values="0 0 0 0 0.880286397 0 0 0 0 0.885493323 0 0 0 0 0.889832428 0 0 0 1 0"/>
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1"/>
              <feMergeNode in="shadowMatrixOuter2"/>
            </feMerge>
          </filter>
          <filter id="prefix__e" width="134.6%" height="132.3%" x="-13.8%" y="-12.9%" filterUnits="objectBoundingBox">
            <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5"/>
            <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
            <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter2"/>
            <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation="1"/>
            <feColorMatrix in="shadowBlurOuter2" result="shadowMatrixOuter2" values="0 0 0 0 0.880286397 0 0 0 0 0.885493323 0 0 0 0 0.889832428 0 0 0 1 0"/>
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1"/>
              <feMergeNode in="shadowMatrixOuter2"/>
            </feMerge>
          </filter>
        </defs>
        <g fill="none" fill-rule="evenodd">

          <slot name="g"/>

        </g>
      </svg>

      <slot/>
    </div>
  </div>
</template>

<script>

export default {}
</script>

<style scoped>

</style>
